/**
 * Крестик закрытия bottom-sheet. Заменил декоративную «чёрточку-свайп»
 * (sheet-handle): жеста свайпа у шторок нет, чёрточка обещала его зря.
 * Праздничные листы (CelebrationSheet, RatingLevelUpSheet) крестика не имеют
 * намеренно — их закрывает только «Забрать» (ack).
 */
export function SheetClose({ onClose }: { onClose: () => void }) {
  return (
    <button className="sheet-close" onClick={onClose} aria-label="Закрыть">
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        aria-hidden
      >
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </button>
  );
}
